var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeLine = function SvgEyeLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 3.898c4.853 0 8.89 3.492 9.737 8.1-.846 4.608-4.884 8.1-9.737 8.1s-8.89-3.492-9.737-8.1c.846-4.608 4.884-8.1 9.737-8.1m0 14.4a8.104 8.104 0 0 0 7.9-6.3 8.104 8.104 0 0 0-15.8 0 8.105 8.105 0 0 0 7.9 6.3m0-2.25a4.05 4.05 0 1 1 0-8.1 4.05 4.05 0 0 1 0 8.1m0-1.8a2.25 2.25 0 1 0 0-4.499 2.25 2.25 0 0 0 0 4.5Z"
  })));
};
export default SvgEyeLine;